<template>
  <v-expansion-panels focusable>
    <v-expansion-panel v-for="(r, i) in resource.data" :key="'resource-'+i"  style="cursor:pointer;">
      <v-expansion-panel-header>
        <v-row class="pa-0 align-center">
          <v-col cols="6" md="2" :class="`${arabic?'arFont':'enFont'} pa-0 py-1`" PROGRAM v-if="r.program_name">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                  <v-chip color="secondary" 
                    label x-small style="text-transform:uppercase;" 
                    v-if="r.program_name && r.program_name.slug"
                  >{{r.program_name.slug}}</v-chip>
                  <v-progress-circular indeterminate v-if="!r.program_name || !r.program_name.slug" color="primary"></v-progress-circular>
                </span>
              </template>
              <div class="text-center">
                <div :class="`${arabic?'arFont':'enFont'}`" style="text-transform:uppercase;"
                  v-if="r.program_name && r.program_name.slug"
                >{{r.program_name.slug}}</div>
              </div>
            </v-tooltip>
          </v-col>
          <v-col cols="6" md="4" :class="`${arabic?'arFont':'enFont'} pa-0 py-1 font-weight-bold`" NAME>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <span class="px-1" v-bind="attrs" v-on="on">@{{ r.time }} | {{ r.day }}</span>
              </template>
              <div class="text-center">
                <div :class="`${arabic?'arFont':'enFont'}`">
                  <span v-if="r.created_at">
                  <v-icon size="10">date_range</v-icon>
                  {{r.created_at.split('T')[0]}} |
                  <v-icon size="10">schedule</v-icon>
                  {{r.created_at.split('T')[1].split('.')[0]}}</span>
                </div>
              </div>
            </v-tooltip>
          </v-col>
          <v-col cols="6" md="4" :class="`${arabic?'arFont':'enFont'} pa-0 py-1 font-weight-bold`" NAME>
            NEXT: {{r.next_date}} @ {{r.time}}
          </v-col>
          <v-col cols="6" md="2" :class="`${arabic?'arFont':'enFont'} pa-0 py-1 adminSwitch text-center`" EDITBUTTON>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" color="primary" 
                  :disabled="r.lock" v-if="!match"
                  x-small @click.stop="edit(r)">
                  <v-icon left size="12">create</v-icon>
                  {{i18n.editIconTooltip}}
                </v-btn>
              </template>
              <span :class="`${arabic?'arFont':'enFont'} pa-0`">
                {{i18n.editIconTooltip}}
              </span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-divider class="pb-3"></v-divider>
        
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import { format, render, cancel, register } from 'timeago.js';
export default {
  props:['resourceSettings', 'resource' , 'resourceKeys', 'match'],
  methods:{
    openLink(url) {
      window.open(url, '_blank');
    },
    getColor(status) {
      if(status == 'new') {
        return 'success'
      } else
      if(status == 'to_create') {
        return '#9c27b0'
      } else
      if(status == 'confirmed') {
        return 'primary'
      } else
      if(status == 'interview') {
        return '#8bc34a'
      } else
      if(status == 'accepted') {
        return '#00bcd4'
      } else
      if(status == 'need_follow_up' || status == 'out_of_reach') {
        return "#FFC107"
      } else {
        return 'error'
      }
    },
    edit(r) {
      this.$emit('editLead', r)
    },
    getFormat(d){
      return format(d)
    },
    clipboardSuccessHandler ({ value, event }){
      this.$emit('copyS', { value, event })
    },
    clipboardErrorHandler ({ value, event }) {
      this.$emit('copyF', { value, event })
    },
  },
  computed:{
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
    user(){
      return this.$store.state.user
    },

  }
}
</script>

<style>

</style>